module.exports = {
  SITE: "https://www.dokuforte.com",
  EMAIL: "dokuforte@dokuforte.com",
  SITE_DEV: "https://dev.dokuforte.co.il",
  API_HOST: "https://backend.dokuforte.co.il",
  PHOTO_SOURCE: "https://d1gpvpdw24w4jv.cloudfront.net/",
  PHOTO_BUCKET: "dokuforte",
  FACEBOOK_APP_ID: "224763373980256",
  THUMBNAILS_QUERY_LIMIT: 40,
  BREAKPOINT_PHONE_XS: 360,
  BREAKPOINT_PHONE_SM: 480,
  BREAKPOINT_PHONE: 640,
  BREAKPOINT_TABLET: 768,
  BREAKPOINT_DESKTOP: 1024,
  BREAKPOINT_DESKTOP_LG: 1220,
  CAROUSEL_SLIDESHOW_DELAY: 4000,
  DEFAULT_THEME: "light",
  LOCALES: {
    en: "English",
    he: "Hebrew",
  },
}
